import { Pipe, PipeTransform } from '@angular/core';
import { LeadNoteTags } from "app/private/main-shared/lead-notes-modal/_models/lead-note.model";

@Pipe({
    name: 'tagged',
    standalone: false
})
export class TaggedPipe implements PipeTransform {

  /**
   * Replace plain text tags with HTML links to things.
   */
  transform(value: string, tagged: LeadNoteTags): string {
    // replace linebreaks with <br>
    value = (value || '').replace(/\r\n|\r|\n/g, '<br>');

    // find tags and replace them with links
    value.match(/@\[\w+:\w+:\d+]/g) // e.g. "... blah @[user:id:123456] yada ..."
      ?.forEach((tag: string, index: number) => {
        const [_unused, type, key, id] = tag.match(/@\[(\w+):(\w+):(\d+)]/);
        const matchingThing = tagged?.[type]?.find(thing => thing[key]?.toString() === id);
        const name = TaggedPipe.nameOfMatchingThing(matchingThing, type, id);
        value = value.replace(
          tag,
          `<a class="tagged"`
          // + ` onclick="window.routerSubject.next('${link}');"` // https://stackoverflow.com/a/42519497/134189
          + ` data-tag="${type}:${key}:${id}"` // used when reverting the tag to plain text
          + `>@${name}</a>`
        );
      });

    return value;
  }

  private static nameOfMatchingThing(matchingThing, type, id): string {
    if (matchingThing) {
      switch (type) {
        case 'user':
          return matchingThing.name;
      }
    }
    return `[${type} ${id}]`;
  }

}
